import { EPackingStatus } from "./compilation";
import { FinishedProductModel } from "./finishedProduct";

export enum EBoxStatus {
  free = 0,
  assignedSpo,
  assignedPallet,
  invoiced,
  damaged,
  lost,
  retesting,
}

export const BoxStatus: Record<EBoxStatus, string> = {
  [EBoxStatus.free]: 'free',
  [EBoxStatus.assignedSpo]: 'assigned',
  [EBoxStatus.assignedPallet]: 'assigned',
  [EBoxStatus.invoiced]: 'invoiced',
  [EBoxStatus.damaged]: 'damaged',
  [EBoxStatus.lost]: 'lost',
  [EBoxStatus.retesting]: 'retesting',
};

export class CaseDetails {
  boxId: number;
  selected: boolean;
  case: string;
  lot: string;
  tc: string
  tcDate: Date;
  prodDate: Date;
  quantity: number;
  boxType: string; // CB1, CB2, ....
}

export class SpoBoxModel {
  _id?: string;

  boxId?: number;
  spo: string;
  spoPos: number
  spoProduct: string;
  selected?: boolean; // not in DB
  case: string;
  // tc: string[];
  boxType: string;
  quantity: number;
  status: EBoxStatus;
  docRef?: string;
  docRefPos?: number;
  docRefProduct?: string;
  palletRef?: string;
  dispatchDate?: Date;
  weight: number;
  shelfLifeText?: string;
  shelfLifeDate?: Date;
  remarks?: string;
  remarksFontSize?: number;
  grossWeightOverride?: number;
  lot: string[] // not in db
  prodDate: Date[] // not in db
  tc: string[]; // not in db
  tcDate: Date[]; // not in db
  dnStatus: EPackingStatus; // not in db
}